import { endPoint } from "./base.config"

export const voucherLabel = {
  getAll: `${endPoint}voucherLabels/:companyId`,
}

export const voucher2Label = {
  update: `${endPoint}voucher2Labels`,
}